"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonMixin = exports.buttonInverseColorMixin = exports.buttonDestructiveMixin = exports.buttonCustomColorMixin = exports.buttonSecondaryMixin = exports.buttonPrimaryMixin = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _propTypes = require("../prop-types");

var fontSizeMixin = function fontSizeMixin(_ref) {
  var theme = _ref.theme,
      small = _ref.small;
  return "font-size: ".concat(theme.selectors.fontSize(small ? 'T100' : 'T200'));
};

var paddingMixin = function paddingMixin(_ref2) {
  var small = _ref2.small,
      secondary = _ref2.secondary,
      tertiary = _ref2.tertiary,
      iconOnly = _ref2.iconOnly,
      disabled = _ref2.disabled;
  if (tertiary) return "padding: 0;";
  if (iconOnly) return 'padding: 4px;';

  if (disabled && !tertiary) {
    return "padding: ".concat(small ? '2px 16px 3px' : '10px 24px', ";");
  }

  if (secondary) {
    return "padding: ".concat(small ? '2px 16px 5px' : '10px 24px', ";");
  }

  return "padding: ".concat(small ? '4px 16px 5px' : '12px 24px', ";");
};

var getPillMinWidth = function getPillMinWidth(small) {
  return "min-width: ".concat(small ? '96px' : '128px', ";");
};

var getColorFg = function getColorFg(_ref3) {
  var normal = _ref3.normal,
      secondaryHover = _ref3.secondaryHover,
      secondaryActive = _ref3.secondaryActive,
      secondaryFocus = _ref3.secondaryFocus,
      disabled = _ref3.disabled,
      tertiary = _ref3.tertiary,
      tertiaryHover = _ref3.tertiaryHover,
      tertiaryActive = _ref3.tertiaryActive,
      tertiaryDisabled = _ref3.tertiaryDisabled;
  return function (_ref4) {
    var isDisabled = _ref4.disabled,
        isHover = _ref4.hover,
        isActive = _ref4.active,
        isTertiary = _ref4.tertiary,
        isSecondary = _ref4.secondary,
        isFocus = _ref4.focus;
    var color = normal;
    if (isDisabled) color = disabled;

    if (isTertiary) {
      color = tertiary;
      if (isDisabled) color = tertiaryDisabled;else if (isHover) color = tertiaryHover;else if (isActive) color = tertiaryActive;
    } else if (isSecondary) {
      if (isDisabled) color = disabled;else if (isHover) color = secondaryHover;else if (isActive) color = secondaryActive;else if (isFocus) color = secondaryFocus;
    }

    return "color: ".concat(color, ";");
  };
};

var getColorBg = function getColorBg(_ref5) {
  var normal = _ref5.normal,
      disabled = _ref5.disabled,
      hover = _ref5.hover,
      active = _ref5.active,
      focus = _ref5.focus;
  return function (_ref6) {
    var isDisabled = _ref6.disabled,
        isHover = _ref6.hover,
        isActive = _ref6.active,
        isTertiary = _ref6.tertiary,
        isFocus = _ref6.focus;
    var color = normal;
    if (isTertiary) color = 'transparent';else if (isDisabled) color = disabled;else if (isHover) color = hover;else if (isActive) color = active;else if (isFocus && focus) color = focus;
    return "background-color: ".concat(color, ";");
  };
};

var pillCommonMixin = function pillCommonMixin(_ref7) {
  var theme = _ref7.theme,
      _ref7$small = _ref7.small,
      small = _ref7$small === void 0 ? false : _ref7$small,
      _ref7$secondary = _ref7.secondary,
      secondary = _ref7$secondary === void 0 ? false : _ref7$secondary,
      _ref7$tertiary = _ref7.tertiary,
      tertiary = _ref7$tertiary === void 0 ? false : _ref7$tertiary,
      _ref7$disabled = _ref7.disabled,
      disabled = _ref7$disabled === void 0 ? false : _ref7$disabled,
      _ref7$iconOnly = _ref7.iconOnly,
      iconOnly = _ref7$iconOnly === void 0 ? false : _ref7$iconOnly,
      colorBg = _ref7.colorBg,
      colorFg = _ref7.colorFg,
      colorFocus = _ref7.colorFocus,
      colorFocusOffset = _ref7.colorFocusOffset;
  return "\n  user-select: none;\n  box-sizing: border-box;\n  font-family: ".concat(theme.selectors.fontFamily('primary'), ";\n  border-radius: ").concat(tertiary ? 0 : 1000, "px;\n  border: ").concat(disabled ? 'solid' : 'none', ";\n  border-width: ").concat(tertiary ? '0px' : '2px', ";\n  border-color: ").concat(disabled ? (0, _utils.darken)(theme.selectors.color('white'), 0.05) : '', ";\n  ").concat(tertiary ? '' : getPillMinWidth(small), ";\n  ").concat(paddingMixin({
    small: small,
    secondary: secondary,
    tertiary: tertiary,
    iconOnly: iconOnly,
    disabled: disabled
  }), ";\n  ").concat(fontSizeMixin({
    theme: theme,
    small: small
  }), ";\n  justify-content: center;\n  text-align: center;\n  align-items: stretch;\n  white-space: nowrap;\n  transition: box-shadow .2s, border-color .2s;\n  box-shadow: none;\n  ").concat(secondary && !tertiary && !disabled ? "border: 2px solid ".concat(theme.selectors.color('primary'), ";") : '', "\n  ").concat(disabled ? '' : ":focus {\n      ".concat(tertiary ? "\n        outline: 2px solid ".concat(colorFocus, ";\n        outline-offset: 2px;") : "\n        outline: 0;\n        ".concat(secondary ? "border-color: ".concat(theme.selectors.color('white'), ";") : '', "\n        box-shadow: 0 0 0 2px ").concat(colorFocusOffset, ",\n                    0 0 0 4px ").concat(colorFocus, ";"), "\n    }"), "\n  cursor: ").concat(disabled ? 'not-allowed' : 'pointer', ";\n  font-weight: ").concat(theme.selectors.fontWeight('medium'), ";\n  ").concat(colorFg({
    disabled: disabled,
    tertiary: tertiary,
    secondary: secondary
  }), "\n  ").concat(colorBg({
    disabled: disabled,
    tertiary: tertiary
  }), "\n\n  :hover {\n    ").concat(tertiary && !disabled ? "\n      text-decoration: underline;" : "", "\n    ").concat(colorBg({
    disabled: disabled,
    tertiary: tertiary,
    hover: true
  }), "\n    ").concat(colorFg({
    disabled: disabled,
    tertiary: tertiary,
    secondary: secondary,
    hover: true
  }), "\n  }\n\n  :focus {\n    ").concat(colorBg({
    disabled: disabled,
    tertiary: tertiary,
    focus: true
  }), "\n    ").concat(colorFg({
    disabled: disabled,
    tertiary: tertiary,
    secondary: secondary,
    focus: true
  }), "\n  }\n\n  :active {\n    ").concat(colorBg({
    disabled: disabled,
    tertiary: tertiary,
    active: true
  }), "\n    ").concat(colorFg({
    disabled: disabled,
    tertiary: tertiary,
    secondary: secondary,
    active: true
  }), "\n  }\n");
};

var buttonPrimaryMixin = function buttonPrimaryMixin(_ref8) {
  var primary = _ref8.primary,
      small = _ref8.small,
      disabled = _ref8.disabled,
      destructive = _ref8.destructive,
      tertiary = _ref8.tertiary,
      inverseColor = _ref8.inverseColor,
      iconOnly = _ref8.iconOnly,
      hasIcon = _ref8.hasIcon,
      theme = _ref8.theme;
  if (destructive || inverseColor || !primary) return '';
  var colorFg = getColorFg({
    normal: theme.selectors.color('white'),
    disabled: (0, _utils.lighten)(theme.selectors.color('accent1'), 0.35),
    tertiary: theme.selectors.color('primary'),
    tertiaryHover: theme.selectors.color('primaryLight'),
    tertiaryActive: theme.selectors.color('primaryDark'),
    tertiaryDisabled: (0, _utils.lighten)(theme.selectors.color('accent1'), 0.35)
  });
  var colorBg = getColorBg({
    normal: theme.selectors.color('primary'),
    disabled: theme.selectors.color('white'),
    hover: theme.selectors.color('primaryLight'),
    active: theme.selectors.color('primaryDark')
  });
  var colorFocus = theme.selectors.color(tertiary ? 'primaryDark' : 'primary');
  var colorFocusOffset = theme.selectors.color('white');
  return pillCommonMixin({
    theme: theme,
    small: small,
    iconOnly: iconOnly,
    hasIcon: hasIcon,
    tertiary: tertiary,
    disabled: disabled,
    colorBg: colorBg,
    colorFg: colorFg,
    colorFocus: colorFocus,
    colorFocusOffset: colorFocusOffset
  });
};

exports.buttonPrimaryMixin = buttonPrimaryMixin;

var buttonSecondaryMixin = function buttonSecondaryMixin(_ref9) {
  var primary = _ref9.primary,
      destructive = _ref9.destructive,
      iconOnly = _ref9.iconOnly,
      hasIcon = _ref9.hasIcon,
      small = _ref9.small,
      disabled = _ref9.disabled,
      tertiary = _ref9.tertiary,
      inverseColor = _ref9.inverseColor,
      theme = _ref9.theme;
  if (primary || destructive || inverseColor) return '';
  var colorFg = getColorFg({
    normal: theme.selectors.color('primary'),
    secondaryHover: theme.selectors.color('primary'),
    secondaryActive: theme.selectors.color('primary'),
    secondaryFocus: theme.selectors.color('primary'),
    disabled: (0, _utils.lighten)(theme.selectors.color('accent1'), 0.35),
    tertiary: theme.selectors.color('primary'),
    tertiaryHover: theme.selectors.color('primaryLight'),
    tertiaryActive: theme.selectors.color('primaryDark'),
    tertiaryDisabled: (0, _utils.lighten)(theme.selectors.color('accent1'), 0.35)
  });
  var colorBg = getColorBg({
    normal: theme.selectors.color('white'),
    disabled: theme.selectors.color('white'),
    hover: theme.selectors.color('accent6'),
    active: theme.selectors.color('accent5'),
    focus: theme.selectors.color('accent6')
  });
  var colorFocus = theme.selectors.color('primaryDark');
  var colorFocusOffset = theme.selectors.color('white');
  return pillCommonMixin({
    theme: theme,
    small: small,
    iconOnly: iconOnly,
    hasIcon: hasIcon,
    secondary: true,
    tertiary: tertiary,
    disabled: disabled,
    colorBg: colorBg,
    colorFg: colorFg,
    colorFocus: colorFocus,
    colorFocusOffset: colorFocusOffset
  });
};

exports.buttonSecondaryMixin = buttonSecondaryMixin;

var buttonCustomColorMixin = function buttonCustomColorMixin(_ref10) {
  var destructive = _ref10.destructive,
      small = _ref10.small,
      disabled = _ref10.disabled,
      tertiary = _ref10.tertiary,
      inverseColor = _ref10.inverseColor,
      theme = _ref10.theme,
      iconOnly = _ref10.iconOnly,
      _ref10$backgroundColo = _ref10.backgroundColor,
      backgroundColor = _ref10$backgroundColo === void 0 ? 'black' : _ref10$backgroundColo,
      _ref10$color = _ref10.color,
      color = _ref10$color === void 0 ? 'white' : _ref10$color;

  if (inverseColor || destructive || !(color || backgroundColor)) {
    return '';
  }

  var customColor = theme.selectors.colorOrNull(color) || color;
  var customColorBg = theme.selectors.colorOrNull(backgroundColor) || backgroundColor;
  var colorFg = getColorFg({
    normal: customColor,
    disabled: (0, _utils.lighten)(customColorBg, 0.7),
    tertiary: customColorBg,
    tertiaryHover: (0, _utils.darken)(customColorBg, 0.1),
    tertiaryActive: (0, _utils.darken)(customColorBg, 0.2),
    tertiaryDisabled: (0, _utils.lighten)(customColorBg, 0.7)
  });
  var colorBg = getColorBg({
    normal: customColorBg,
    disabled: (0, _utils.lighten)(customColorBg, 0.9),
    hover: (0, _utils.darken)(customColorBg, 0.1),
    active: (0, _utils.darken)(customColorBg, 0.2)
  });
  var colorFocus = customColorBg;
  var colorFocusOffset = theme.selectors.color('white');
  return pillCommonMixin({
    theme: theme,
    small: small,
    iconOnly: iconOnly,
    tertiary: tertiary,
    disabled: disabled,
    colorBg: colorBg,
    colorFg: colorFg,
    colorFocus: colorFocus,
    colorFocusOffset: colorFocusOffset
  });
};

exports.buttonCustomColorMixin = buttonCustomColorMixin;

var buttonDestructiveMixin = function buttonDestructiveMixin(_ref11) {
  var destructive = _ref11.destructive,
      inverseColor = _ref11.inverseColor,
      props = (0, _objectWithoutProperties2.default)(_ref11, ["destructive", "inverseColor"]);
  if (inverseColor || !destructive) return '';
  return buttonCustomColorMixin((0, _objectSpread2.default)({
    backgroundColor: 'negative'
  }, props));
};

exports.buttonDestructiveMixin = buttonDestructiveMixin;

var buttonInverseColorMixin = function buttonInverseColorMixin(_ref12) {
  var inverseColor = _ref12.inverseColor,
      small = _ref12.small,
      iconOnly = _ref12.iconOnly,
      disabled = _ref12.disabled,
      tertiary = _ref12.tertiary,
      theme = _ref12.theme;
  if (!inverseColor) return '';
  var WHITE = theme.selectors.color('white');
  var TEXT_COLOR = theme.selectors.colorOrNull(inverseColor) || inverseColor;
  var colorFg = getColorFg({
    normal: TEXT_COLOR,
    disabled: TEXT_COLOR,
    tertiary: WHITE,
    tertiaryHover: (0, _utils.darken)(WHITE, 0.05),
    tertiaryActive: (0, _utils.darken)(WHITE, 0.1),
    tertiaryDisabled: theme.selectors.color('negativeLight')
  });
  var colorBg = getColorBg({
    normal: WHITE,
    disabled: WHITE,
    hover: (0, _utils.darken)(WHITE, 0.05),
    active: (0, _utils.darken)(WHITE, 0.1)
  });
  var colorFocus = WHITE;
  var colorFocusOffset = TEXT_COLOR;
  return pillCommonMixin({
    theme: theme,
    small: small,
    iconOnly: iconOnly,
    tertiary: tertiary,
    disabled: disabled,
    colorBg: colorBg,
    colorFg: colorFg,
    colorFocus: colorFocus,
    colorFocusOffset: colorFocusOffset
  });
};

exports.buttonInverseColorMixin = buttonInverseColorMixin;
var buttonMixinBase = (0, _utils.combineMixins)(buttonPrimaryMixin, buttonSecondaryMixin, buttonDestructiveMixin, buttonInverseColorMixin);
var buttonMixin = (0, _stencilReactDesc.describe)(buttonMixinBase).description('Provides style options for buttons.');
exports.buttonMixin = buttonMixin;
buttonMixin.propTypes = {
  primary: _stencilReactDesc.PropTypes.bool.description('Use the primary style for the button.'),
  small: _stencilReactDesc.PropTypes.bool.description('Use a smaller size for the button.'),
  disabled: _stencilReactDesc.PropTypes.bool.description('Prevents the button from being clicked.'),
  destructive: _stencilReactDesc.PropTypes.bool.description('Change the style of the button to indicate that it performs a destructive action.'),
  tertiary: _stencilReactDesc.PropTypes.bool.description('Use a less prominent style for the button, without a background.'),
  inverseColor: (0, _propTypes.cssValue)().description('Invert the colors of the button and use the given color as the text color.'),
  iconOnly: _stencilReactDesc.PropTypes.bool.description('Indicates that this button does not contain any text, only an icon.'),
  hasIcon: _stencilReactDesc.PropTypes.bool.description('Indicates that this button contains an icon.')
};